import { memo } from 'react';
import styled from 'styled-components';
import getFirstReleaseYear from '@utils/getFirstReleaseYear';
import SecondaryTitle from '@components/SecondaryTitle/SecondaryTitle';

const List = styled.ul`
  margin-bottom: 3rem;
  padding-left: 20px;
`;

const ListItem = styled.li`
  font-size: 1.2rem;
  margin-bottom: 1rem;
`;

const InfoBox = ({ products }) => {
  const years = {};

  products.map((product) => {
    const year = getFirstReleaseYear(product.product.content.releases);

    if (!years[year]) {
      years[year] = [];
    }

    years[year].push(product.product.title);
  });

  return (
    <>
      <SecondaryTitle>Breakdown by release year</SecondaryTitle>
      <List>
        {Object.keys(years)
          .sort()
          .reverse()
          .map((year) => {
            return (
              <ListItem key={year}>
                <strong>{year}:</strong> {years[year].length}{' '}
                {years[year].length !== 1 ? 'sets' : 'set'}
                <br />
                {years[year].join(', ').trim()}
              </ListItem>
            );
          })}
      </List>
    </>
  );
};

export default memo(InfoBox);
